import React from "react";
import AppLogin from "./AppLogin";
import LanguageSelector from "./LanguageSelector";
import UserControls from "./UserControls";
import {PRODUCTS, SECTIONS} from "./menu";

// The aspose.ai top bar, rendered by this app instead of being injected at runtime by
// https://menucdn.containerize.com/core/engine.min.js. Same markup and class names as the
// "asposeai-en" venture served, so ./header.css (lifted from the same source) still applies.
//
// The upstream engine shipped a `headScript` that wired the burger menu up by hand; that
// behaviour lives in the component state below instead.

// Below this width the bar collapses into the burger menu and top-level entries expand
// in place rather than navigating. Matches the breakpoint used throughout header.css.
const MOBILE = "(max-width: 1024px)";

const isMobile = () =>
    typeof window !== "undefined" && window.matchMedia(MOBILE).matches;

// `i18n` is the page's pageContext.i18n, passed in by wrap-page-element.js.
const Header = ({i18n}) => {
    const [menuOpen, setMenuOpen] = React.useState(false);
    const [openSection, setOpenSection] = React.useState(null);

    // On a narrow viewport a top-level entry opens its submenu instead of following its
    // link - there is nowhere else to put the second level. On desktop the dropdowns are
    // pure CSS hover, so the click just navigates.
    const sectionClick = (label) => (e) => {
        if (!isMobile()) return;
        e.preventDefault();
        setOpenSection(openSection === label ? null : label);
    };

    const anchorClass = (label) =>
        openSection === label ? "mobileanchor openmenu" : "mobileanchor";

    return (
        <div id="DynabicMenuInnerDiv">
            <div className={menuOpen ? "topheader topbutton" : "topheader"}>
                <div className="topsection topsection-panel">

                    <button type="button"
                            className="togglebtn"
                            id="mobile-button"
                            aria-expanded={menuOpen}
                            onClick={() => setMenuOpen(!menuOpen)}>
                        <span className="sr-only">Toggle navigation</span>
                        <span className="icon-bar"/>
                        <span className="icon-bar"/>
                        <span className="icon-bar"/>
                    </button>

                    <div className="venturelogo">
                        <a rel="nofollow" href="https://www.aspose.ai/">
                            <span className="font-0">Aspose</span>
                        </a>
                    </div>

                    {/* All boxes float right, so the app's own session shows outermost,
                        the language switch next to it, then the Aspose account box (usually empty). */}
                    <div className="userlogstatus">
                        <AppLogin/>
                        <LanguageSelector i18n={i18n}/>
                        <div id="DynabicMenuUserControls">
                            <UserControls/>
                        </div>
                    </div>

                    <div className="menuitems">
                        <ul className="topheadermenus twocolmenu">

                            <li>
                                <a rel="nofollow"
                                   href="https://products.aspose.ai/"
                                   className={anchorClass("Products")}
                                   onClick={sectionClick("Products")}>
                                    Products
                                </a>
                                <ul>
                                    <div className="productmenubox">
                                        {PRODUCTS.map(product => (
                                            <a rel="nofollow" key={product.href} href={product.href}>
                                                <em>{product.name}<b> AI Agents</b></em>
                                            </a>
                                        ))}
                                    </div>
                                </ul>
                            </li>

                            {SECTIONS.map(section => (
                                <li key={section.label}>
                                    <a rel="nofollow"
                                       href={section.href}
                                       className={anchorClass(section.label)}
                                       onClick={sectionClick(section.label)}>
                                        {section.label}
                                    </a>
                                    <ul>
                                        {section.items.map(item => (
                                            <li key={item.href}>
                                                <a rel="nofollow" href={item.href}>{item.label}</a>
                                            </li>
                                        ))}
                                    </ul>
                                </li>
                            ))}

                        </ul>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Header;
